export const GET_DATA_ORA = 'GET_DATA_ORA';
export const GET_DATA_ORA_SUCCESS  = 'GET_DATA_ORA_SUCCESS';
export const GET_DATA_ORA_FAIL = 'GET_DATA_ORA_FAIL';
